var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgZoomReset24(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#zoom-reset-24_svg__clip0_2137_37908)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.857 21.37c-.095-.23-.24-.44-.412-.622L19.42 16.73a10.008 10.008 0 001.639-7.06 10.062 10.062 0 00-3.546-6.322 10.073 10.073 0 00-6.89-2.296c-1.37.067-2.693.402-3.91.985a11.14 11.14 0 00-.94.517L7.5 3.874a8.181 8.181 0 013.603-.851 8.131 8.131 0 017.504 5.003 8.063 8.063 0 01.46 4.677 8.125 8.125 0 01-2.224 4.152 8.22 8.22 0 01-4.159 2.219 8.138 8.138 0 01-8.347-3.444 8.094 8.094 0 01-1.37-4.505c0-.172.019-.345.028-.507H1.011c-.115 2.487.7 4.926 2.28 6.858A10.094 10.094 0 0016.7 19.428l4.034 4.027c.355.354.843.555 1.351.555s.988-.201 1.352-.555a1.81 1.81 0 00.412-.622c.096-.23.143-.478.143-.727s-.047-.497-.143-.727l.01-.01z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.697 1.923L3.78 0l-.92.918v5.96h5.97l.92-.919-2.088-2.085"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "zoom-reset-24_svg__clip0_2137_37908"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h24v24H0z"
  })))));
}
export default SvgZoomReset24;